import { RequiredFieldValidation, EmailValidation, MinLengthValidation, CompareFieldsValidation, PhoneValidation, RequiredPatternPasswordFieldValidation, NumberFieldValidation } from '@/validation/validators';
import { NumberminMaxFieldValidation } from '@/validation/validators/number-min-max-field-validation';
import { RequiredPasswordFieldValidation } from '@/validation/validators/required-password-field-validation';
import { UsernameValidation } from '@/validation/validators/username-validation';
export class ValidationBuilder {
    constructor(fieldName, validations) {
        this.fieldName = fieldName;
        this.validations = validations;
    }
    static field(fieldName) {
        return new ValidationBuilder(fieldName, []);
    }
    required() {
        this.validations.push(new RequiredFieldValidation(this.fieldName));
        return this;
    }
    email() {
        this.validations.push(new EmailValidation(this.fieldName));
        return this;
    }
    phone() {
        this.validations.push(new PhoneValidation(this.fieldName));
        return this;
    }
    min(length) {
        this.validations.push(new MinLengthValidation(this.fieldName, length));
        return this;
    }
    sameAs(fieldToCompare) {
        this.validations.push(new CompareFieldsValidation(this.fieldName, fieldToCompare));
        return this;
    }
    patternPassword() {
        this.validations.push(new RequiredPatternPasswordFieldValidation(this.fieldName));
        return this;
    }
    patternUsername() {
        this.validations.push(new UsernameValidation(this.fieldName));
        return this;
    }
    number() {
        this.validations.push(new NumberFieldValidation(this.fieldName));
        return this;
    }
    numberMinMax(min, max) {
        this.validations.push(new NumberminMaxFieldValidation(this.fieldName, min, max));
        return this;
    }
    password() {
        this.validations.push(new RequiredPasswordFieldValidation(this.fieldName));
        return this;
    }
    build() {
        return this.validations;
    }
}
